"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpanLinkChooserState = void 0;
const tslib_1 = require("tslib");
const core_shared_1 = require("@ikegps/core-shared");
const core_api_1 = require("@ikegps/core-api");
const mobx_1 = require("mobx");
const i18n_1 = require("../../i18n");
const services_1 = require("../../services");
const store_1 = require("../../store");
const multi_list_chooser_state_1 = require("./multi.list.chooser.state");
class SpanLinkChooserState extends multi_list_chooser_state_1.MultiChooserState {
    constructor(collection) {
        super((0, i18n_1.Translate)(i18n_1.T.SPAN));
        this.collection = collection;
    }
    get groups() {
        const spanLinkRecords = this.nearbySpans;
        if (spanLinkRecords == null) {
            return null;
        }
        if (spanLinkRecords.length === 0) {
            this.setError(i18n_1.T.SPAN_LINK_NO_MATCH);
            return [];
        }
        this.setError(null);
        const items = [];
        for (const spanLinkRecord of spanLinkRecords) {
            const collection = spanLinkRecord.collection;
            const spanInstance = spanLinkRecord.instance;
            const collectionTitle = this.getCollectionTitle(collection);
            items.push({
                key: collection.id,
                value: `${collection.schema.titleField.displayName} = ${collectionTitle}, ${spanInstance.title}`,
            });
        }
        return [
            {
                title: (0, i18n_1.Translate)(i18n_1.T.SPAN_LINK_SELECT_CONTENT),
                items,
                selected: items.length > 0 ? items[0].key : null,
            },
        ];
    }
    selectDefaultValue() {
        const spanLinkRecords = this.nearbySpans;
        if (spanLinkRecords == null || spanLinkRecords.length === 0) {
            this.setValue(null);
        }
        else {
            this.setValue([spanLinkRecords[0].collection.id]);
        }
    }
    get nearbySpans() {
        var _a;
        const tagSummary = store_1.AppStore.TagSummary.get(this.collection.jobId);
        if (tagSummary == null || tagSummary.revisions == null) {
            return null;
        }
        const collections = [];
        for (const collectionRevision of tagSummary.revisions) {
            const collection = store_1.AppStore.Collection.get(collectionRevision);
            if (collection != null) {
                collections.push(collection);
            }
        }
        if (collections.length === 0) {
            return null;
        }
        // Build set of collection IDs that this collection already has span links to.
        // Walk the same subform fields that findLinks uses, get the vector field ID
        // from the provider rules, and check for existing collection links.
        const linkedCollectionIds = new Set();
        for (const fieldSchema of this.collection.schema.fields) {
            if (fieldSchema.type !== core_api_1.IkeFieldType.FORM) {
                continue;
            }
            const subform = this.collection.getField(fieldSchema.id);
            const rules = services_1.Services.SubFormLink.getRules(subform.schema);
            if (rules == null || !subform.hasValue()) {
                continue;
            }
            for (const instance of subform.value) {
                const vectorField = instance.getOptionalField(rules.vector);
                if ((vectorField === null || vectorField === void 0 ? void 0 : vectorField.isCollectionLink()) && ((_a = vectorField.stateValue) === null || _a === void 0 ? void 0 : _a.collectionId)) {
                    linkedCollectionIds.add(vectorField.stateValue.collectionId);
                }
            }
        }
        const candidateCollections = collections.filter((collection) => collection.id !== this.collection.id && !linkedCollectionIds.has(collection.id));
        const links = services_1.Services.SubFormLink.findLinks(this.collection, candidateCollections);
        // Only fore spans should be shown as copyable options
        return links.filter((link) => {
            var _a;
            let spanTypeValue = null;
            try {
                const spanSubForm = new core_shared_1.SpanSubFormAdaptor(link.instance);
                spanTypeValue = spanSubForm.spanType;
            }
            catch (_e) {
                // If the subform instance is not using the new span subform type fall back on hardcoded fields as a possibility
                const typeField = link.instance.getOptionalField(core_shared_1.PoleFieldIds.SPAN.TYPE) ||
                    link.instance.getOptionalField(core_shared_1.IkePoleForemanFieldIds.SPAN_TYPE);
                spanTypeValue = (_a = typeField === null || typeField === void 0 ? void 0 : typeField.value) !== null && _a !== void 0 ? _a : null;
            }
            return spanTypeValue === core_shared_1.SpanType.NextPole || spanTypeValue === core_shared_1.IPFSpanType.FORE_SPAN;
        });
    }
    setValue(value) {
        this._value = value;
    }
    getSelectedSpanLinkRecord() {
        var _a, _b;
        if (this.value == null) {
            return null;
        }
        return (_b = (_a = this.nearbySpans) === null || _a === void 0 ? void 0 : _a.find((record) => record.collection.id === this.value[0])) !== null && _b !== void 0 ? _b : null;
    }
    getCollectionTitle(collection) {
        const title = collection.title;
        return title != null ? title : (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MISSING_TITLE);
    }
}
exports.SpanLinkChooserState = SpanLinkChooserState;
tslib_1.__decorate([
    mobx_1.action
], SpanLinkChooserState.prototype, "selectDefaultValue", null);
tslib_1.__decorate([
    mobx_1.computed
], SpanLinkChooserState.prototype, "nearbySpans", null);
tslib_1.__decorate([
    mobx_1.action
], SpanLinkChooserState.prototype, "setValue", null);
//# sourceMappingURL=span.link.chooser.state.js.map